export default {
  common: {
    And: '和',
    GotIt: '明白',
    GoHome: '去首页',
    Cancel: '取消',
    Submit: '提交',
    Detail: '详情',
    OhMy: '哎呀!',
    EmptyData: '暂无数据',
    Loading: '--- 加载中 ---',
    SubmitSuccess: '提价成功',
    ChooseFile: '选择一个文件',
    FileSupport: '文件类型不支持',
    ExceedMaxSize3M: '超过最大尺寸限制(3M)',
    ErrAgain: '系统错误，请稍后再试。',
    NoSignal: '这里没有信号!我们找不到您要找的页面。',
    ErrorRefresh: '页面信息已更改！请刷新此页面继续！'
  },
  course: {
    Lesson: '节课',
    Lessons: '节课',
    Replay: '回放',
    Live: '直播',
    LiveTime: '直播时间',
    Syllabus: '课程章节',
    CourseDetails: '课程详情',
    CourseNoStarted: '课程还没有开始',
    JoinCourse: '加入课程',
    JoinCourseSuccess: '已经成功提交选课申请，审核通过后您可以查看课程内容',
    WorkTypeEpParts: '经典例题',
    WorkTypeExItems: '课后习题',
    WorkTypeCmkItems: '随堂测试',
    SubclassTitle: '小课名称',
    QuestionSetter: '命题人',
    Score: '得分',
    Percent: '百分比',
    Avg: '平均分',
    NoMoreCourses: '--- 没有更多课程了 ---',
    NoReadySelling: '对不起，这门课程还没有准备好出售或已经停止销售。',
    NoReplay: '暂无回放',
    HasApply: '已报名',
    Approved: '审核通过',
    Reject: '驳回',
    LiveDuring: '直播时间： {start} - {end}'

  },
  question: {
    Like: '喜欢',
    Interesting: '有趣',
    Question: '题目',
    AnalysisSolution: '分析与解答',
    LastQuestion: '上一题',
    NextQuestion: '下一题',
    QuestionList: '题目列表',
    AnswerResults: '答题结果',
    FullMarks: '满分',
    YourScore: '你的得分',
    ReportProblems: '题目反馈',
    ReportProblemsTitle: '请让我们知道你的反馈。',
    Unfamiliar: '不熟悉的',
    NeedToExplain: '需讲解',
    ItTooSimple: '太简单了',
    Custom: '自定义',
    FeedbackDesc: '反馈描述',
    CustomPlaceholder: '请输入你想反馈的内容',
    ReExamination: '重新开始',
    KeyboardShortcutsIntroduction: '键盘快捷键介绍',
    IntroductionOne: '1. 按shift + ←/→切换至上一题/下一题',
    IntroductionTwo: '2. 只需在每个问题中点击选择，它就会自动保存',
    EasyQuestionTips: '这是一个自由回答问题。你不需要输入答案。',
    SingleSelection: '单选题',
    MultipleSelections: '多选题',
    GapFilling: '填空题',
    FreeResponse: '解答题',
    UnAnswerTips: '有{num}道题未完成作答，确认交卷吗？'

  },
  auth: {
    Login: '登录',
    LoginTitle: '欢迎登录课程系统！',
    SignUp: '注册',
    Password: '密码',
    ForgotPassword: '忘记密码?',
    NoAccount: '没有账号?',
    AlreadyAccount: '已经有账号?',
    EmailOrMobile: '邮箱/手机号',
    PasswordPlaceholder: '8 - 32 字符',
    TermsOfUse: '使用条款',
    PrivacyPolicy: '隐私政策',
    LoginTips: '通过登录课程系统，您同意我们的',
    RegisterTips: '通过注册课程系统，您同意我们的',
    RegisterDesc: '加入课程系统，你将获得优秀的物理课程学习材料。我们会保存你所有的学习进度。还有一件事，这些都是免费的!',
    AccountRequired: '需要邮箱/手机登录',
    AccountFormatErr: '请以正确的格式填写邮件/手机',
    PasswordRequired: '登录时需要输入密码',
    PasswordFormatErr: '密码长度为8 ~ 32个字符',
    LoginSuccess: '登录成功!',
    CheckAccount: '请检查您的邮箱/手机，稍后再试。',
    Inaccuracy: '您的帐号或密码不正确。',
    NoSignUp: '您的账号还没有注册。',
    ResetPasswordMax: '您可以重置新密码。每天最多两次。',
    VerificationCode: '验证码',
    VerificationCodePlaceholder: '6位数字',
    CreatePassword: '创建密码',
    CreatePasswordPlaceholder: '8 - 32个字符，请注意使用大写和小写。',
    GetVerificationCode: '获取验证码',
    ResetPassword: '重置密码',
    VerificationCodeRequired: '请输入验证码',
    VerificationCodeFormatErr: '验证码错误',
    CreatePasswordRequired: '请创建密码',
    CreatePasswordFormatErr: '密码长度为8 ~ 32个字符。为了安全起见，最好设置一个以前从未使用过的密码',
    HasSendVerificationCode: '验证码已发送至您的邮箱/手机。请检查您的收件箱以找到验证码。',
    AccountHasSignUp: '这个邮箱/手机已经有账户了。如果是你的，你可以用它登录。',
    Err3SecondsAgainLater: '系统错误，页面将在3秒后刷新，请稍后再试。',
    SendTwice: '不能在60秒内发送两次验证码',
    NoResetPasswordTime: '您已经用完了重置密码的所有机会，请明天再试。',
    NoSignUpCheckAccount: '这个邮箱/手机还没有注册。请确保您输入的电子邮件/手机账号是正确的。',
    Max5timeCode: '每个邮箱/手机账号每天有5次获得验证码的机会，你已经用完了。请使用最新消息中的验证码进行注册，或者明天再试。',
    LikeRobot: '对不起，你表现得像个机器人，所以没有通过测试。您可以稍后再试。',
    CheckInputValue: '哦，出错了，请确保输入正确，稍后再试。',
    CreateAccount: '创建帐户',
    Nickname: '您的姓名',
    NicknamePlaceholder: '创建一个不超过32个字符的姓名',
    NicknameRequired: '您的姓名不能为空',
    NicknameErr: '您的姓名长度不超过32个字符。',
    VerificationCodeHasExpired: '验证码已过期。',
    VerificationCodeError: '验证码不正确。',
    RetryAfter: '{seconds}秒后重试。'
  },
  nav: {
    Account: '个人中心',
    Admin: '后台管理',
    MyCourses: '我的课程',
    Logout: '退出登录',
    CourseCenter: '课程中心',
    Feedback: '反馈',
    BackToTop: '回到顶部',
    FeedbackSuccess: '我们收到了您的反馈，谢谢!',
    FeedbackTitle: '我们期待您对我们网站的反馈!',
    FeedbackPlaceholder: '请告诉我们你想说什么。这对我们真的很有帮助',
    Homework: '作业',
    CourseDetail: '课程详情'
  },
  user: {
    Proton: '质子',
    Neutron: '中子',
    IGetIt: '我明白了',
    Signature: '个性签名',
    EditSignature: '编辑你的个性签名',
    EditSignaturePlaceholder: '今天没刷题别懊丧，没关系放轻松，反正你明天也不会刷',
    EditSignatureTips: '一旦您进入前10名学习者列表，您的个性化签名以及您的个人资料照片和您的姓名将显示在其他用户的页面上。个人签名不超过200个字符。',
    ProtonNeutronTips: '什么是质子和中子?',
    ProtonNeutronIntroduction: '质子和中子说明',
    Username: '中文名',
    UsernamePlaceholder: '请输入您的中文名',
    Nickname: '您的姓名',
    NicknamePlaceholder: '请输入您的英文名',
    School: '学校',
    SchoolPlaceholder: '请输入您的学校',
    Grade: '年级',
    GradePlaceholder: '请选择您的年级',
    EditNickname: '编辑您的姓名',
    EditNicknamePlaceholder: '例如: Albert Einstein',
    AvatarPopper: '更改头像',
    EditAvatarTitle: '编辑你的头像'
  }
}
